export interface ISwapFailureAnalysis {
    centerId: number,
    centerAlias: string,
    totalOffers: number,
    totalAccepts: number,
    totalDeclines: number,
    totalNoResponse: number,
    totalCommencements: number,
    totalTransplants: number,
    failures: number,
    avoidableFailures: number,
    billableFailures: number,
    unavoidableIncludingCovidFailures: number,
    covidFailures: number,
    adjustedFailures: number,
    swapFailureRate: number,
    swapSuccessRate: number,
    rankSwapFailureRate:number,
    rank: number,
    category: string
}